// Importing required Highcharts modules
var Highcharts = require('highcharts');
require('highcharts/modules/no-data-to-display')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);

// Exposing Highcharts to the global scope
window.Highcharts = Highcharts;

// Setting global options for Highcharts
Highcharts.setOptions({
  lang: {
    loading: 'Lade Daten...',
    noData: 'Keine Daten vorhanden',
    resetZoom: 'Zoom zurücksetzen',
    months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  },
});

// Function to be called when the DOM content is loaded
document.addEventListener('DOMContentLoaded', function() {
  loadCharts();
});

/**
 * Load Charts
 */
window.loadCharts = function() {
  // Generating ChartFactoryMemberYear
  var chartFactoryMemberYear = document.querySelectorAll('[data-generate-chart-factory-member-year]');
  if (chartFactoryMemberYear.length > 0) {
    chartFactoryMemberYear.forEach(function(element) {
      generateChartFactoryMemberYear(
          element.getAttribute('id'),
          element.getAttribute('data-years'),
          element.getAttribute('data-factories'),
          element.getAttribute('data-members'),
      );
    });
  }
};

/**
 * Generate ChartFactoryMemberYear
 * @param container
 * @param years
 * @param factories
 * @param members
 */
window.generateChartFactoryMemberYear = function(container, years, factories, members) {
  // Parsing JSON strings to arrays
  const jsonYears = JSON.parse(years);
  const jsonFactories = JSON.parse(factories);
  const jsonMembers = JSON.parse(members);

  Highcharts.chart(container, {
    accessibility: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    chart: {
      type: 'line',
    },
    title: {
      text: 'Entwicklung der Betriebe und Mitglieder pro Jahr',
    },
    xAxis: {
      categories: jsonYears,
      gridLineWidth: 1,
    },
    yAxis: {
      title: {
        text: 'Anzahl',
      },
      labels: {
        formatter: function() {
          return this.value; // Zeigt den vollständigen Wert an, ohne 'k'
        }
      }
    },
    series: [
      {
        name: 'Anzahl Betriebe',
        data: jsonFactories,
      }, {
        name: 'Mitglieder',
        data: jsonMembers,
      },
    ],
  });
};
